<template>
  <b-table
    ref="refAcceptedInnerTable"
    :items="list"
    responsive
    :fields="tableColumns"
    primary-key="id"
    show-empty
    :empty-text="$t('No matching records found')"
    :busy="isBusy"
    class="accepted-org-table position-relative"
    thead-class="hidden"
  >
    <!-- Column: Index -->
    <template #cell(index)="data">
      <span style="display: block; width: 30px">
        <feather-icon
          v-if="data.item.id"
          :icon="data.detailsShowing ? 'ChevronDownIcon': 'ChevronRightIcon'"
          @click="data.toggleDetails"
        />
        {{ prefix + (data.index + 1) }}
      </span>
    </template>
    <template
      #row-details="data"
      style="padding: 0"
    >
      <accepted-inner
        :letter-id="data.item.id"
        :prefix="prefix + (data.index + 1) + '.'"
        :table-columns="tableColumns"
      />
    </template>

    <template #cell(name)="data">
      {{ getOrgName(data.item) }}
    </template>

    <template #table-busy>
      <div class="text-center text-danger my-2">
        <b-spinner
          variant="primary"
          label="Text Centered"
        />
      </div>
    </template>
  </b-table>
</template>

<script>
import { BTable, BSpinner } from 'bootstrap-vue'
import { isString } from '@vueuse/core'
import axios from '@/libs/axios'
// eslint-disable-next-line import/no-self-import
import AcceptedInner from './AcceptedInner.vue'

export default {
  name: 'AcceptedInner',
  components: {
    BTable,
    BSpinner,
    AcceptedInner,
  },
  props: {
    letterId: {
      type: Number,
      required: true,
    },
    prefix: {
      type: String,
      default: '',
    },
    tableColumns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      list: [],
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.isBusy = true
      axios.get(`/letters/${this.letterId}/accepted_letter_inner/`).then(res => {
        this.list = res.data.table1
        this.isBusy = false
      })
    },
    getOrgName(data) {
      let { name } = data
      if (isString(name)) {
        name = JSON.parse(name)
      }
      let code = ''
      if (data.code) code += `${data.code} - `

      return code + this.$langName(name)
    },
  },
  setup() {
    const isBusy = true
    return {
      isBusy,
    }
  },
}
</script>

<style>
</style>
